import { useEffect, useRef } from 'react'
import { departedShareAskers } from '../services/share-only-roster'
import { usePresenterRequestsStore } from '../store/presenter-requests.store'

/**
 * A screen-share page's pending ask goes when the page does (contract §8):
 * the page asks again after its own rejoin, so a card left up would be
 * answering nobody. Everyone else's card stays up as it always has
 * (`departedShareAskers` has the rule).
 *
 * `present` is everyone else in the room — the meeting's remote peers. Each
 * new roster is compared with the one just before it.
 */
export function useShareAskerDepartures(present: ReadonlyMap<string, unknown>): void {
  const presentIdsRef = useRef<ReadonlySet<string>>(new Set())
  useEffect(() => {
    const now = new Set(present.keys())
    const before = presentIdsRef.current
    presentIdsRef.current = now
    const { incoming, remove } = usePresenterRequestsStore.getState()
    for (const id of departedShareAskers(before, now, incoming)) remove(id)
  }, [present])
}
